module.exports = __webpack_public_path__ + "img/dots-left.2b9a59e5.png";